import {
	Component,
	EventEmitter,
	Input,
	OnInit,
	Output
}                                      from '@angular/core';
import { FormControlBaseComponent }    from '@app/core/bases/form-control-base/form-control-base.component';
import { IFormData }                   from '@core/interfaces/form.interface';
import {
	NgbDateStruct,
	NgbInputDatepicker
}                                      from '@ng-bootstrap/ng-bootstrap';
import { PlacementArray }              from '@ng-bootstrap/ng-bootstrap/util/positioning';
import { IDateRangePickerChangeEvent } from '@shared/form-elements/form-daterangepicker/form-date-range-picker.model';

@Component( {
	selector: 'app-form-date-range-picker[formEntityIdFrom][formEntityIdTo][formGroup][configFrom][configTo]',
	templateUrl: './form-date-range-picker.component.html',
	styleUrls: [ './form-date-range-picker.component.scss' ]
} )
export class FormDateRangePickerComponent extends FormControlBaseComponent implements OnInit {

	@Input() formEntityIdFrom: string;

	@Input() formEntityIdTo: string;

	@Input() configFrom: IFormData;

	@Input() configTo: IFormData;

	@Input() datepickerFromPopupPlacement: PlacementArray;

	@Input() datepickerToPopupPlacement: PlacementArray;

	@Output() changeEventEmitter: EventEmitter<IDateRangePickerChangeEvent> = new EventEmitter<IDateRangePickerChangeEvent>();

	toDateMinimum: NgbDateStruct;

	constructor() {
		super();
	}

	ngOnInit() {
		this.formGroup.get( this.formEntityIdFrom )?.valueChanges
		.subscribe( ( val: Date ) => {
			if ( val ) {
				const fromDate: Date = val;
				this.toDateMinimum = { year: fromDate.getFullYear(), month: fromDate.getMonth() + 1, day: fromDate.getDate() };

				const toDate: Date = this.formGroup.get( this.formEntityIdTo )?.value;
				if ( toDate && fromDate > toDate ) {
					this.formGroup.get( this.formEntityIdTo )?.reset();
				}
			} else {
				this.toDateMinimum = null;
			}
		} );
	}

	setDate( datePicker: NgbInputDatepicker ) {
		datePicker.toggle();
	}

	onValueChanged( date: Date, id: string ) {
		this.changeEventEmitter.emit( { date, id } );
	}
}
